<template>
  <v-skeleton-loader
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot name="default"/>
  </v-skeleton-loader>
</template>
<script>
export default {
  name: "Loader"
}
</script>

<style scoped>
</style>

<!-- Loader wrapper of Vuetify skeleton-loader, no customisation yet -->
